import {put, takeEvery} from "redux-saga/effects";
import {Package} from "../../../Models/Package";
import {
    packageCreateError,
    packageCreateSuccess,
    packageLoadError,
    packageLoadSuccess,
    packagesGetError,
    packagesGetSuccess,
    packageUpdateError,
    packageUpdateSuccess,
} from "./actions";
import * as TYPES from "./types";

export default function* packagesSagas() {
    yield takeEvery(TYPES.PACKAGES_GET_REQUEST, packagesGetRequest);
    yield takeEvery(TYPES.PACKAGE_LOAD_REQUEST, packageLoadRequest);
    yield takeEvery(TYPES.PACKAGE_CREATE_REQUEST, packageCreateRequest);
    yield takeEvery(TYPES.PACKAGE_UPDATE_REQUEST, packageUpdateRequest);
}

function* packagesGetRequest(action) {
    try {
        const response = yield Package.index({
            ...action.payload,
        });

        yield put(
            packagesGetSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(packagesGetError(error));
    }
}

function* packageLoadRequest(action) {
    try {
        const response = yield Package.find(action.payload);

        yield put(
            packageLoadSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(packageLoadError(error));
    }
}

function* packageCreateRequest(action) {
    try {
        const response = yield Package.create(action.payload);

        yield put(
            packageCreateSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(packageCreateError(error));
    }
}

function* packageUpdateRequest(action) {
    try {
        const response = yield Package.update(action.payload.id, action.payload);

        yield put(
            packageUpdateSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(packageUpdateError(error));
    }
}
